<template>
  <router-view />
</template>
<script>
export default {
  name: 'App'
}
</script>
<style>
/* ===== 全局基础样式 =====
   登录/注册页使用 100vh(100dvh) 铺满视口，浏览器默认的 body 外边距会
   额外撑出 8px 并产生滚动条，这里统一清零；同时禁止 iOS 横屏字号放大 */
html,
body {
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100%;
}
</style>